module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQ0MCIgaGVpZ2h0PSI0NTIiIHZpZXdCb3g9IjAgMCAxNDQwIDQ1MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuNDk5MjY4IDM4NS4zNTlDMC40OTkyNjggMzg1LjM1OSAyNjUuNjMxIDQwNy42NzUgNzcxLjkyOCAyOTEuMTA1QzEyNzguMjMgMTc0LjUzNCAxNDQwIDI4LjMwNzQgMTQ0MCAyOC4zMDc0IiBzdHJva2U9IiNGRDhDNzciIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNMCA0NTAuODM4QzAgNDUwLjgzOCAzNDIuNTI0IDQ2MS4xMTUgNzgxLjkxNCAzMTcuODI1QzEyMjEuMyAxNzQuNTM0IDE0NDAgMSAxNDQwIDEiIHN0cm9rZT0iI0ZEOEM3NyIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/images/testim_vectors.svg
// module id = 1236
// module chunks = 0